module.exports = __webpack_public_path__ + "static/media/umeed.0cee7c08.png";